angular
  .module('app')
  .component('clientErrors', {
    templateUrl: 'app/components/clientErrors/ClientErrors.html',
    controller: ClientErrors,
    bindings: {
      hotelConfig: '<',
      code: '<'
    }
  });

function ClientErrors(ERROR_CODES, $translate) {
  this.ERROR_CODES = ERROR_CODES;
  this.$translate = $translate;
}

ClientErrors.prototype = {
  $onInit: function () {
    this.error = this.getError(this.code);
  },

  getError: function (code) {
    code = parseInt(code, 10);
    switch (code) {
      case this.ERROR_CODES.UNAVAILABLE_ROOM_GROUP:
        return {
          title: this.$translate.instant('error.UNAVAILABLE_ROOM_GROUP'),
          icon: 'fa-tags',
          message: this.$translate.instant('error.UNAVAILABLE_ROOM_GROUP_MESSAGE')
        };
      default:
        return {
          title: '500',
          icon: 'fa-exclamation-circle',
          message: this.$translate.instant('error.500')
        };
    }
  }
};
